import { actionTypes } from "../contants/actionTypes";

const setNestedValue = (obj, path, value) => {
    const keys = path.split('.');
    const result = { ...obj };
    let current = result;

    keys.forEach((key, index) => {
        if (index === keys.length - 1) {
            current[key] = value;
        } else {
            current[key] = { ...(current[key] || {}) };
            current = current[key];
        }
    });

    return result;
};

export const cacheReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.setNested:
            return setNestedValue(state, action.payload.path, action.payload.data);

        case actionTypes.clearPath:
            return setNestedValue(state, action.payload.path, undefined);

        case actionTypes.resetCache:
            return {};
        default:
            return state;
    }
};